import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from '../../../../core/util/core/Fetch';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { useKeysStore } from '../../../../core/store/useKeysStore';

function Form() {
    const { keys } = useKeysStore();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter();

    const hiddenValues = {};

    if (profileFilter.pdc_entity_id) {
        hiddenValues.pdc_entity_id = profileFilter.pdc_entity_id;
    }

    const path = '/qualifications/';
    const paths = {
        endpointSave: config.endpoints.backend + 'documentations/save',
        endpointGetById: config.endpoints.backend + 'documentations/getById',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllDocumenationCategories:
            config.endpoints.backend + 'documentationcategories/getall',
        endpointGetAllDocumentTypes:
            config.endpoints.backend + 'documenttypes/getall',

        urlGoBack: path + 'list',
        pathView: path + 'view'
    };

    const labels = {
        labelTitleAdd: 'Nova Documentação - Qualificação',
        labelTitleEdit: 'Editar Documentação - Qualificação',
        labelTitleView: 'Visualizar Documentação - Qualificação'
    };

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues
            },
            fields: [
                {
                    name: 'pdc_category_id',
                    type: 'select',
                    label: 'Categoria',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllDocumenationCategories,
                        label: 'name',
                        value: 'id'
                    },
                    value: values.pdc_category_id
                        ? values.pdc_category_id
                        : null,
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                    readOnly: !!values.pdc_category_id
                },
                {
                    name: 'pdc_document_type_id',
                    type: 'select',
                    label: 'Tipo de Documento',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllDocumentTypes,
                        label: 'name',
                        value: 'id',
                        params: {
                            filter: {
                                pdc_category_id: values.pdc_category_id
                            }
                        }
                    },
                    value: values.pdc_document_type_id
                        ? values.pdc_document_type_id
                        : null,
                    validations: {
                        required: true
                    },
                    readOnly: !!values.pdc_document_type_id && !id,
                    columnSize: 6
                },
                {
                    name: 'title',
                    type: 'text',
                    label: 'Título',
                    maxLength: 500,
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'publish_date',
                    type: 'date',
                    label: 'Data de Publicação',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'file',
                    type: 'fileS3',
                    extensionAccept: '.jpeg,.jpg,.png,.ico,.pdf,.xlsx,.docx',
                    limitFileSize: keys?.limitFileSizeDefault,
                    label: 'Arquivo',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'pdc_project_ids',
                    type: 'multiinput',
                    label: 'Projetos',
                    sortBy: 'index',
                    form: [
                        {
                            name: 'pdc_project_id',
                            type: 'select',
                            label: 'Projeto',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllProjects,
                                label: 'project_name',
                                value: 'id',
                                params: {
                                    filter: {
                                        ...profileFilter
                                    }
                                }
                            },
                            validations: {
                                required: true
                            }
                        }
                    ],
                    validations: {
                        required: false
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        };
        form.values = values;
        return form;
    };

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id });
            }

            values.pdc_category_id = 'ad44e4d4-6797-4fff-a41c-63cd3b1f7d64';

            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            );
        };
        load();
    }, []);

    return <div>{formContent}</div>;
}
export default Form;
